import { render, staticRenderFns } from "./ListaGruposSelecionaveis.vue?vue&type=template&id=2ab21f7a"
import script from "./ListaGruposSelecionaveis.vue?vue&type=script&lang=js"
export * from "./ListaGruposSelecionaveis.vue?vue&type=script&lang=js"
import style0 from "./ListaGruposSelecionaveis.vue?vue&type=style&index=0&id=2ab21f7a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports